import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchGroupGames, fetchKOGames } from "../../api/games";
const initialState = {
  loading: false,
  groupGames: [],
  knockoutGames: [],
};

export const getGroupStageGamesAction = createAsyncThunk(
  "games/getGroupStageGames",
  async (props, { rejectWithValue }) => {
    const { contestId } = props;

    try {
      const res = await fetchGroupGames({
        contest_id: contestId,
      });

      return res;
    } catch (err) {
      console.error("Error in [getGroupStageGames] action: ", err);

      return rejectWithValue(err?.response?.data);
    }
  },
);

export const getKOGamesAction = createAsyncThunk(
  "games/getKOGames",
  async (props, { rejectWithValue }) => {
    const { contestId } = props;

    try {
      const res = await fetchKOGames({
        contest_id: contestId,
      });

      return res;
    } catch (err) {
      console.error("Error in [getKOGames] action: ", err);

      return rejectWithValue(err?.response?.data);
    }
  },
);

const gamesSlice = createSlice({
  name: "games",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getGroupStageGamesAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getGroupStageGamesAction.fulfilled, (state, action) => {
      state.groupGames = action.payload.group_stage_games;
      state.loading = false;
    });

    builder.addCase(getKOGamesAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getKOGamesAction.fulfilled, (state, action) => {
      state.knockoutGames = action.payload.knockout_games;
      state.loading = false;
    });

    builder.addCase(getGroupStageGamesAction.rejected, (state) => {
      state.loading = false;
    });
    builder.addCase(getKOGamesAction.rejected, (state) => {
      state.loading = false;
    });
  },
});

export default gamesSlice.reducer;
